import { useToken } from "../../items/UseToken";




export function GoogleLoginButton({ agentGuid, email, handleFinish }) {


   

 

    return (
        <>
        <button
                onClick={() => handleFinish(true)}
            style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "white",
                color: "#3c4043",
                border: "1px solid #dadce0",
                borderRadius: "4px",
                padding: "10px 16px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: "Roboto, sans-serif",
            }}
        >
            {/* Ikonka Google jako SVG */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="20px"
                height="20px"
            >
                <path
                    fill="#4285F4"
                    d="M24 9.5c3.54 0 6 1.54 7.38 2.84l5.43-5.43C33.61 3.85 29.15 1.5 24 1.5 14.58 1.5 6.67 7.91 4.14 16.68l6.64 5.16C12.3 14.56 17.63 9.5 24 9.5z"
                />
                <path
                    fill="#34A853"
                    d="M46.5 24.5c0-1.6-.14-3.1-.39-4.5H24v9h12.62c-.54 2.8-2.14 5.18-4.62 6.79l7.19 5.59C43.61 37.58 46.5 31.48 46.5 24.5z"
                />
                <path
                    fill="#FBBC05"
                    d="M10.78 28.34A14.48 14.48 0 0 1 9.5 24c0-1.52.26-2.98.72-4.34l-6.64-5.16A22.4 22.4 0 0 0 1.5 24c0 3.65.88 7.1 2.46 10.16l6.82-5.82z"
                />
                <path
                    fill="#EA4335"
                    d="M24 46.5c6.15 0 11.32-2.03 15.1-5.5l-7.19-5.59c-2.02 1.36-4.61 2.18-7.91 2.18-6.37 0-11.7-5.06-13.22-11.34l-6.82 5.82C6.67 40.09 14.58 46.5 24 46.5z"
                />
                </svg>
                {email && <div><span>Authorized with <br></br> {email} <br></br> (click to Refresh)</span></div>}
                {!email && <span>Authorize with Google</span>}
            </button>
        </>
    );
}